import { render, staticRenderFns } from "./EditarProductoDialog.vue?vue&type=template&id=afd9a890"
import script from "./EditarProductoDialog.vue?vue&type=script&lang=js"
export * from "./EditarProductoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports